import styled from 'styled-components'
import { FiChevronRight } from 'react-icons/fi'

export const Container = styled.div`
  max-width: 760px;
`

export const Title = styled.h2`
  margin: 0 0 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 800;
  font-size: 1.25rem;
  line-height: 1.2;
  letter-spacing: -0.2px;
  color: #212529;
  position: relative;
  padding-bottom: 8px;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 56px;
    height: 3px;
    border-radius: 999px;
    background: linear-gradient(90deg, #0d6efd 0%, #6f42c1 100%);
  }

  svg {
    color: #0d6efd;
    flex-shrink: 0;
  }
`

export const Item = styled.div`
  margin-bottom: 12px;
`

export const Header = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 14px 16px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
  transition: box-shadow 160ms ease, transform 80ms ease;

  &:hover { box-shadow: 0 4px 10px rgba(16, 24, 40, 0.08); }
  &:active { transform: translateY(1px); }
  &:focus-visible { outline: 2px solid #0d6efd; outline-offset: 2px; }
  border-bottom-left-radius: ${({ $open }) => ($open ? '0' : '12px')};
  border-bottom-right-radius: ${({ $open }) => ($open ? '0' : '12px')};
`

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`

export const PairBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  font-size: 0.95rem;
  color: #212529;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  padding: 6px 10px;
  border-radius: 999px;
`

export const Meta = styled.span`
  color: #6c757d;
  font-size: 0.9rem;
`

export const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  white-space: nowrap;
`

export const Rate = styled.span`
  font-weight: 700;
  color: #212529;
`

export const Chevron = styled(FiChevronRight)`
  transition: transform 160ms ease-in-out;
  transform: rotate(${({ $open }) => ($open ? 90 : 0)}deg);
  color: #6c757d;
  flex-shrink: 0;
`

export const Panel = styled.div`
  border: 1px solid #e9ecef;
  border-top: none;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  background: #ffffff;
  padding: ${({ $open }) => ($open ? '12px 16px' : '0 16px')};
  box-shadow: 0 6px 12px rgba(16, 24, 40, 0.06);
  overflow: hidden;
  max-height: ${({ $open }) => ($open ? '400px' : '0')};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transform: translateY(${({ $open }) => ($open ? '0' : '-4px')});
  transition: max-height 220ms ease, opacity 160ms ease, transform 220ms ease, padding 220ms ease;
`